<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <div class="row" v-loading="loading">
        <div class="col-xl-12 order-xl-1">
          <el-form :model="ideaDetailForm" ref="ideaDetailForm">
            <card shadow type="secondary">
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-12">
                    <h3 class="mb-0">Proje Bilgisi</h3>
                  </div>
                </div>
              </div>
              <template>
                <h6 class="heading-small text-muted mb-4">Genel Bilgiler</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-4">
                      <label class="form-control-label">Başlığı</label>
                      <el-form-item prop="title" class="form-control-alternative">
                        <el-input v-model="ideaDetailForm.title" readonly
                                  placeholder="Proje Adı"></el-input>
                      </el-form-item>
                    </div>

                    <div class="col-lg-4">
                      <label class="form-control-label">Kategorisi</label>
                      <el-form-item prop="title" class="form-control-alternative">
                        <el-input v-model="ideaDetailForm.category" readonly
                                  placeholder="Kategori"></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-lg-4">
                      <label class="form-control-label">Görünürlük Durumu</label>
                      <el-form-item prop="title" class="form-control-alternative" v-if="ideaDetailForm.visibility == 1">
                        <el-input value="Herkese Açık" readonly
                                  placeholder="Görünürlük Durumu"></el-input>
                      </el-form-item>

                      <el-form-item prop="title" class="form-control-alternative" v-else>
                        <el-input value="Herkese Kapalı" readonly
                                  placeholder="Görünürlük Durumu"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <label class="form-control-label">Tipi</label>
                      <el-form-item prop="type" class="form-control-alternative">
                        <el-input :value="ideaDetailForm.type == 0 ? 'Fikir' : 'Proje'" readonly
                                  placeholder="Tipi"></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-lg-4">
                      <label class="form-control-label">Durum</label>
                      <el-select class="w-100 form-control-alternative"
                                 v-model="ideaDetailForm.status"
                                 placeholder="Durumu">
                        <el-option
                            v-for="stat in status"
                            :key="stat.value"
                            :label="stat.label"
                            :value="stat.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="col-lg-4">
                      <label class="form-control-label">İncelenme Durumu</label>
                      <el-select class="w-100 form-control-alternative"
                                 v-model="ideaDetailForm.review_status"
                                 placeholder="İncelenme Durumu">
                        <el-option
                            v-for="stat in reviewStatus"
                            :key="stat.value"
                            :label="stat.label"
                            :value="stat.value">
                        </el-option>
                      </el-select>
                    </div>
                     <div class="col-lg-12" v-if="ideaDetailForm.has_answers == 0">
                      <label class="form-control-label">Açıklama</label>
                         <textarea class="w-100 form-control" column="5" style="background-color:white;height: 19vh;" :value="ideaDetailForm.description" readonly
                                  placeholder="Açıklama"></textarea>
                    </div>
                    <div v-if="ideaOtherForm.file_name !== null" class="col-lg-6">
                      <label class="form-control-label">Belgesi</label>
                      <br>
                      <a :href="'https://vizyonergenc.com/file-server/'+ideaOtherForm.file_collection_name +'/' + ideaOtherForm.file_id + '/' +ideaOtherForm.file_name+'?token='+token "
                         target="_blank">{{ ideaOtherForm.file_name }}</a>
                    </div>
                    <div v-if="ideaOtherForm.images_id !== null" class="col-lg-6">
                      <label class="form-control-label">Görseli</label>
                      <br>
                      <a :href="'https://vizyonergenc.com/file-server/'+ideaOtherForm.images_collection_name +'/' + ideaOtherForm.images_id + '/' +ideaOtherForm.images_name+'?token='+token "
                         target="_blank">{{ ideaOtherForm.images_name }}</a>
                    </div>
                  </div>
                  <!--soru cevap alanı-->
                  <div class="pt-4">
                    <vsa-list style="width: 100%;max-width: 100%;">
                      <!-- Here you can use v-for to loop through items  -->
                      <vsa-item v-for="item in ideaAnswers" v-bind:key="item.id">
                        <vsa-heading>
                          <span style="font-size: 0.8rem!important;">{{ item.questions.text }}</span>
                        </vsa-heading>
                        <vsa-content style="padding: 10px!important;">
                          <span style="font-size: 0.8rem">{{ item.answer }}</span>
                        </vsa-content>
                      </vsa-item>
                    </vsa-list>
                  </div>
                  <!--soru cevap alanı -->
                </div>
                <hr class="my-4"/>
                <div class="row justify-content-end margin-right-1 margin-top-10">
                  <el-button
                      size="small"
                      type="primary"
                      @click="updateIdeaStatus('ideaDetailForm',false)"
                  >{{ variables.get('save') }}
                  </el-button>
                </div>
              </template>

            </card>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import VuePhoneNumberInput from 'vue-phone-number-input';
//import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent
} from 'vue-simple-accordion';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
import {variables} from "../../langs/tr";
import * as axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: 'IdeaDetail',
  components: {
    //VuePhoneNumberInput
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,

  },
  computed: {
    ...mapGetters({
      getUserModel: "userModule/getUserModel",
    })
  },
  data() {
    return {
      token: localStorage.getItem('access_token'),
      variables,
      loading: true,
      ideaAnswers: null,
      ideaDetailForm: {
        title: "",
        id: null,
        category: "",
        type: null,
        status: null,
        review_status: null,
        deleted_at: null,
        visibility: null,
        description:null,
        has_answers:null,
      },
      ideaOtherForm: {
        file_name: null,
        file_collection_name: null,
        file_id: null,
        images_name: null,
        images_collection_name: null,
        images_id: null,
      },
      customToolbar: [
        [{header: [false, 1, 2, 3, 4, 5, 6]}, "bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        ["code-block"],
      ],
      reviewStatus: [{
        value: 0,
        label: 'Bekleniyor'
      }, {
        value: 1,
        label: 'İnceleniyor'
      }, {
        value: 2,
        label: 'Kapandı'
      }],
      status: [{
        value: 0,
        label: 'Pasif'
      }, {
        value: 1,
        label: 'Aktif'
      }],
    }
  },
  created() {
    this.getIdeaCategory();
    this.getIdeasInformation();
  },
  methods: {
    async getIdeaCategory() {
      await axios
          .get("admin/ideas/category")
          .then((response) => {
            this.categoryList = response.data;
            this.loading = false;
          })
          .catch(function (error) {
            this.loading = false;
            console.log(error);
            this.$notify.warning({
              title: "Kategoriler getirilemedi.",
              message: error.response.data.join(" "),
            });
          });
    },

    updateIdeaStatus() {
      let form = new FormData()
      form.append("status", this.ideaDetailForm.status);
      form.append("id", this.ideaDetailForm.id);
      form.append("review_status", this.ideaDetailForm.review_status);

      axios.post('admin/ideas/update', form).then(response => {
        if (response.status == 200) {
          this.$notify.success({
            title: 'Başarılı',
            message: 'Bilgi güncellemesi başarıyla gerçekleştirildi.',
          });
        }
      }).catch(() => {
        this.$notify.info({
          title: 'Bir hata oluştu',
          message: 'Boş alan bırakmış ya da yanlış bir bilgi girmiş olabilirsiniz.',
        });
      })


    },
    trimFile(word) {
      return word.replace(/^\s+|\s+$/g, "");
    },
    getIdeasInformation() {
      axios.get("admin/ideas/detail/" + this.$route.params.id).then((response) => {
        this.ideaDetailForm.id = this.$route.params.id;
        this.ideaDetailForm = response.data.result;
        this.ideaDetailForm.category = response.data.result.categories.name;
        this.ideaAnswers = response.data.idea_answers;
        console.log(response.data);
        if (response.data.media !== null) {
          this.ideaOtherForm.file_name = response.data.media.file_name
          this.ideaOtherForm.file_collection_name = response.data.media.collection_name;
          this.ideaOtherForm.file_id = response.data.media.id;

        }

        if (response.data.images !== null) {
          this.ideaOtherForm.images_name = response.data.images.file_name
          this.ideaOtherForm.images_collection_name = response.data.images.collection_name;
          this.ideaOtherForm.images_id = response.data.images.id;

        }


        this.loading = false;
      })
          // eslint-disable-next-line no-unused-vars
          .catch(err => {

            this.loading = false;
            this.$notify.info({
              title: 'Bir hata oluştu',
              message: 'Bilgiler getirilirken bir hata meydana geldi',
            });
          })
    },
  }
};
</script>
<style scoped>
.el-input-group__append, .el-input-group__prepend, .el-input__inner {
  border-radius: 0.375rem !important;
  border: none !important;
  height: 42px !important;
  padding: 0.625rem 0.75rem !important;
  transition: box-shadow .15s ease, -webkit-box-shadow .15s ease !important;
}

.el-input__inner:focus {
  -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.mask-error {
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 14px;
}

.vsa-list {
  --vsa-default-icon-size: 0.40;
  --vsa-border-style: solid;
  --vsa-heading-padding: 0.6rem 0.6rem;
  --vsa-content-padding: 0.7rem 0.7rem;
}
</style>
